import React, { useState } from "react";
import { Link } from "react-router-dom";
import { PRIVACY_POLICY } from "../../config";
import { LICENSE_AGREMENT } from "../../config";
import "./styles.scss";
import Loader from "../loader/loader";



  const PublicFooter = ({ heading, to, toText }) => {
    const [loading, setLoading] = useState(false);
  
    const handlePrivacyPolicyClick = (e) => {
      e.preventDefault();
      setLoading(true);
      
      // Show loader for 10 seconds before navigating
      setTimeout(() => {
        setLoading(false);
        window.location.href = PRIVACY_POLICY;
      }, 5000);
    };
  
    return (
      <div className={"pb-footer"}>
         {loading && <Loader fullSize />}
        <div className={"pf-heading"}>
          <p style={{ fontFamily:'helvetica-lt-std-roman' }}>{heading}</p>
          <Link to={to} style={{ fontFamily:'helvetica-lt-std-roman', fontWeight:'bold', fontSize:'20px' }}>{toText}</Link>
        </div>
        <div className={"pf-links"}>
          <Link to={LICENSE_AGREMENT} style={{ fontFamily:'helvetica-lt-std-roman' }}>License Agreement </Link>
          <Link to={PRIVACY_POLICY} style={{ fontFamily:'helvetica-lt-std-roman' }}   onClick={handlePrivacyPolicyClick}> - Privacy Policy</Link>
        </div>
      </div>
    );
  };
  

export default PublicFooter;
